import React, { useCallback, useMemo, useRef } from 'react';

import { Box, Slider, Typography } from '@mui/material';

import { fmtShortDate } from './utils';

interface Props {
  dates: Array<string>;
  onRangeCommit: (range: Array<number>) => void;
}

export default function DateRangeSlider({ dates, onRangeCommit }: Props) {
  const max = dates.length - 1;
  const labelRef = useRef<HTMLSpanElement>(null);
  const defaultValue = useMemo(() => [0, max], [max]);

  const updateLabel = useCallback(
    (val: Array<number>) => {
      if (labelRef.current) {
        labelRef.current.textContent = `${fmtShortDate(dates[val[0]] ?? '')} - ${fmtShortDate(dates[val[1]] ?? '')}`;
      }
    },
    [dates],
  );

  return (
    <Box sx={{ bgcolor: 'grey.50', p: 3, borderRadius: '12px', border: 1, borderColor: 'divider', mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>Date Range</Typography>
        <Typography ref={labelRef} sx={{ fontSize: 14, fontWeight: 700, color: 'primary.main' }}>
          {fmtShortDate(dates[0] ?? '')} - {fmtShortDate(dates[max] ?? '')}
        </Typography>
      </Box>
      <Slider
        defaultValue={defaultValue}
        onChange={(_, val) => updateLabel(val)}
        onChangeCommitted={(_, val) => onRangeCommit(val)}
        min={0}
        max={max}
        color="primary"
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{fmtShortDate(dates[0] ?? '')}</Typography>
        <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{fmtShortDate(dates[max] ?? '')}</Typography>
      </Box>
    </Box>
  );
}
